import { uid } from '../../../utils/random';
import { request as getPossibleBets } from './get-possible-bets';

export function request(userId, combination, legsIds, channel, isFreeBet, selectedFreeBets) {
    userId = parseInt(userId, 10);

    return (dispatch, getState) => {
        let bets = getState().betslip.getIn([ 'bets', userId ]);
        let legs = getState().betslip.getIn([ 'legs', userId ]).toJS();
        let selectedLegs = legsIds.map(legId => legs[legId]);

        let multiple = {
            uid: 'temp-' + uid(),
            type: combination.get('type'),
            name: combination.get('name'),
            numLines: combination.get('numLines'),
            ewOffered: combination.get('ewOffered'),
            stakePerLine: combination.get('stakePerLine'),
            price: combination.get('price'),
            eachWay: combination.get('eachWay'),
            legs: selectedLegs
        };

        bets = bets
            .map(bet => bet.set('legs', bet.get('legs').map(legId => legs[legId])))
            .push(multiple)
            .toJS();

        dispatch(getPossibleBets(userId, bets, selectedLegs, channel, isFreeBet, selectedFreeBets));

        dispatch({
            type: 'BETSLIP_ADD_MULTIPLE',
            userId,
            multiple
        });
    };
}

export function clear(userId) {
    userId = parseInt(userId, 10);

    return {
        type: 'BETSLIP_CLEAR_MULTIPLE',
        userId
    };
}
